import validate from "/opt/buildhome/repo/frontend/node_modules/.pnpm/nuxt@3.19.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.5.0_@vue+compiler_93fbe9f5c29e32711850427da878ae5d/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/buildhome/repo/frontend/node_modules/.pnpm/nuxt@3.19.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.5.0_@vue+compiler_93fbe9f5c29e32711850427da878ae5d/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}